import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import React from 'react';
import Chip from 'Chip';
import transform from 'chipDataTransform';
import '../reset.css';
import style from './style.css';
import Ad from '@ifeng-fe/ui_pc_ad';
import Banner from './banner/';
import Navigation from './nav/';
import Partner from './partner/';
import Bottom from './bottom/';
import Header from './header/';
import BottomFooter from './footer/';
import FixedBar from './fixedBar/';
// import TopCollapse from './collapse/';
import Stock from './stock';
import FocusBanner from './focusBanner';
import Content from './content';
import StockList from '@/src/pc/components/stockList';
class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;

        const initData = {
            __partnerTitle: {
                title: '精品推荐',
                more: [],
            },
        };
        const { __partnerTitle } = initData;

        const headerData = {
            nav: content.nav,
            topAd: content.topAd,
        };

        const bannerData = {
            search: content.search,
            bannerLogo: content.bannerLogo,
        };

        const partner = {
            partnerTitle: __partnerTitle,
            list: content.partnerlist,
        };

        const footerData = {
            bottomAd: content.bottomAd,
            footer: content.footer,
        };

        const stockData = {
            stockCode: content.stockCode,
            production: content.production,
        };
        const focusData = {
            list: content.flist,
            bankNews: content.bankNews,
            fundNews: content.fundNews,
            InsuranceNews: content.InsuranceNews,
            videoTitle: content.videoTitle,
            video: content.fvideo,
            videoInfo: content.videoInfo,
            videoSlide: content.videoSlide,
        };

        return (
            <div>
                <Header content={headerData} />
                <Banner content={bannerData} />
                <Navigation content={content.navigation} />
                {/* <Stock content={stockData} /> */}
                <div className={style.stockListCon}>
                    {/* 股票行情 */}
                    <StockList />
                </div>
                <FocusBanner content={focusData} />
                <Content content={content} />
                <Partner content={partner} />
                <Bottom content={content.bottom} />
                <BottomFooter content={footerData} />
                <FixedBar />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
